import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleZoneCreation(
  state: State,
  { planzone, zone }: Boundaries["createZone"]["success"],
): State {
  return state.map((req) =>
    planzone.uuid === req.planzone.uuid
      ? {
          ...req,
          zones: [{ ...zone, projects: [] }, ...req.zones],
        }
      : req,
  );
}

export { handleZoneCreation };
